import cls from './ChildrenStatic.module.scss';
import childPurpleImg from '../../assets/images/game/children/purple_1.svg';
import childBlueImg from '../../assets/images/game/children/blue_1.svg';
import childOrangeImg from '../../assets/images/game/children/orange_1.svg';
import childPinkImg from '../../assets/images/game/children/pink_1.svg';
import childGreyImg from '../../assets/images/game/children/grey_1.svg';
import childYellowImg from '../../assets/images/game/children/yellow_1.svg';

const ChildrenStatic = () => {
  return (
    <div className={cls.childrenGroup}>
      <img alt="Child" src={childBlueImg} />
      <img alt="Child" src={childOrangeImg} />
      <img alt="Child" src={childPurpleImg} />
      <img alt="Child" src={childPinkImg} />
      <img alt="Child" src={childGreyImg} />
      <img alt="Child" src={childYellowImg} />
    </div>
  );
};

export default ChildrenStatic;
